import { AuthenticationThunks } from './thunks/authentication-thunks';
import { DashboardThunks } from './thunks/dashboard-thunks';
import { LegalThunks } from './thunks/legal-thunks';
import { NavigationThunks } from './thunks/navigation-thunks';
import { RegistrationThunks } from './thunks/registration-thunks';
import { UserSettingsThunks } from './thunks/user-settings-thunks';
import { TimelineExportThunks } from './thunks/timeline-export-thunk';
import { SignalRConnectionThunks } from './thunks/signalr-connection-thunks';
import { TrendsExportThunks } from './thunks/trends-export-thunk';
import { AlarmThunks } from './thunks/alarm-thunk';
import { SiteThunks } from './thunks/site-thunk';
import { SierraDeviceThunks } from './thunks/sierra-devices-thunk';
import { PxdbDeviceThunks } from './thunks/pxdb-devices-thunk';
import { StarfishDeviceThunks, StarfishChildDeviceThunks } from './thunks/starfish-devices-thunk';
import { UserSuggestionAcceptRejectThunks } from './thunks/alarm-suggestion-thunks';
import { ResetSuggestionThunks } from './thunks/resetSuggestion-thunks';
import { SensorDetailThunks } from './thunks/sensor-details-thunks';

import { MeshDeviceThunks } from './thunks/mesh-devices-thunk';
import { GetSubscriptionThunks } from './thunks/get-subscription-thunk';
import { GetOrgTypeThunks } from './thunks/org-type-thunk';
import { ManageAlarmsThunks } from './thunks/manage-alarms-thunks';
import { ManageDeviceProfilesThunks } from './thunks/manage-device-profiles-thunks';

export const Thunks = {
    Alarm: AlarmThunks,
    Authentication: AuthenticationThunks,
    Dashboard: DashboardThunks,
    Legal: LegalThunks,
    Navigation: NavigationThunks,
    Registration: RegistrationThunks,
    UserSettings: UserSettingsThunks,
    TimelineExport: TimelineExportThunks,
    SignalRConnection: SignalRConnectionThunks,
    Site: SiteThunks,
    TrendExport: TrendsExportThunks,
    SierraDevice: SierraDeviceThunks,
    PXDBDevice: PxdbDeviceThunks,
    MeshDevice: MeshDeviceThunks,
    GetSubscription: GetSubscriptionThunks,
    GetOrgCheck: GetOrgTypeThunks,
    AlarmSuggestion: UserSuggestionAcceptRejectThunks,
    ResetSuggestionThunks: ResetSuggestionThunks,
    SensorDetailThunks: SensorDetailThunks,
    StarfishDevice: StarfishDeviceThunks,
    StarfishChildDevice: StarfishChildDeviceThunks,

    ManageAlarmsThunks: ManageAlarmsThunks,
    ManageDeviceProfilesThunks: ManageDeviceProfilesThunks,
};
